import sitedata from './sitedata'

const data = {
  ...sitedata,
}

export default data